export function selectScreenHelper(context) {
  if (!context.hasOwnProperty('authenticatorKey')) {
    const loader = document.querySelector('#loader');
    if (loader) {
      loader.style.display = 'flex';
    }
    const selectButton = document.querySelectorAll('.list-content > .authenticator-button');
    if (selectButton) {
      selectButton[1].childNodes[0].click();
    }
  }
}

export function reRenderWidget(context, error, timer = 0) {
  const { retry } = this.state;
  const signIn = document.querySelector('#okta-sign-in');
  if (signIn) {
    signIn.style.display = "none";
  }
  this.setState({ showloader: true });
  if (retry < 2) {
    setTimeout(() => {
      this.setState((prevState) => ({ retry: prevState.retry + 1 }));
    }, timer);
  } else {
    if (signIn) signIn.style.display = "block";
    this.setState({ showloader: false });
  }
  if(error && context && error.errorSummary === 'There was an unsupported response from server.'){
    if (context.formName === 'identify') {
        error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.identifyUnsupportedResponse;
    } else if(context.formName === 'select-authenticator-authenticate'){
        error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.authenticateUnsupportedResponse;
    } else if(context.formName === 'authenticator-verification-data'){
        error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.verificationUnsupportedResponse;
    } else if(context.formName === 'challenge-authenticator'){
      if (context.authenticatorKey === 'okta_email' || context.authenticatorKey === 'phone_number'){
          error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.challengeAuthenticatorUnsupportedResponse;
      } else if(context.authenticatorKey === 'okta_password'){
          error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.passwordUnsupportedResponse;
      }
    }
  }
}

const challengeAuthenticatorErrorHelper = (context, error, widget) => {
  if (context.authenticatorKey === 'okta_email' || context.authenticatorKey === 'phone_number'){
    if (error.errorSummary === 'Failed to fetch') {
      error.xhr.responseJSON.errorSummary = widget.options.i18n.en.challengeAuthenticatorFetchFailed;
    } else if (error.errorSummary === 'Load failed') {
      error.xhr.responseJSON.errorSummary = widget.options.i18n.en.challengeAuthenticatorLoadFailed;
    }
  } else if(context.authenticatorKey === 'okta_password'){
    if (error.errorSummary === 'Failed to fetch') {
      error.xhr.responseJSON.errorSummary = widget.options.i18n.en.passwordFetchFailed;
    } else if (error.errorSummary === 'Load failed') {
      error.xhr.responseJSON.errorSummary = widget.options.i18n.en.passwordLoadFailed;
    }
  }
};

export function reTryLogic(context, error) {
  if (context.formName === 'identify') {
    if (this.fetchRetry < 3 && (error.errorSummary === 'Failed to fetch' || error.errorSummary === 'Load failed')) {
      app.logger.getLogger().info("Login Retrying Request.. " + this.fetchRetry);
      error.xhr.responseJSON.errorSummary = 'Retrying Request..';
      setTimeout(() => {
        this.fetchRetry++;
        document.getElementsByClassName('button-primary')[0].click();
      }, 150);
    }
    
    if (error.errorSummary === 'Failed to fetch') {
      error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.fetchFailed;
    } else if (error.errorSummary === 'Load failed') {
      error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.loadFailed;
    }
  } else if(context.formName === 'select-authenticator-authenticate'){
    if (error.errorSummary === 'Failed to fetch') {
      error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.authenticateFetchFailed;
    } else if (error.errorSummary === 'Load failed') {
      error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.authenticateLoadFailed;
    } else if (error.errorSummary === 'Conflicting App User IDs specified on state token') {
      error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.authenticateLoadFailedStateToken;
    }
  } else if(context.formName === 'authenticator-verification-data'){
    if (error.errorSummary === 'Failed to fetch') {
      error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.verificationFetchFailed;
    } else if (error.errorSummary === 'Load failed') {
      error.xhr.responseJSON.errorSummary = this.widget.options.i18n.en.verificationLoadFailed;
    }
  } else if(context.formName === 'challenge-authenticator'){
    challengeAuthenticatorErrorHelper(context, error, this.widget);
  }
}
